/**
 * SignupPage Component
 * Handles user registration with a multi-step wizard.
 */

import React from 'react';
import { SignupWizard } from './signup/SignupWizard';

export const SignupPage: React.FC = () => {
  return <SignupWizard />;
};

export default SignupPage;
